<template>
  <div class="container">
    <coffee-dashboard-tabs initial-tab-value="rewards" />
    <donut-table :headers="tableHeaders" :data="tableData" class="m-tx5">
      <template #status="{ entry }">
        <a v-if="entry.is_gift_card" :href="`/rewards/redemptions/${entry.id}/gift_card_link`" target="_blank" class="link ul">Redeem link</a>
        <div v-else class="t">{{ entry.fulfilled_at ? 'Fulfilled' : 'Unfulfilled' }}</div>
      </template>
    </donut-table>
    <div v-if="isFetching" class="f-jc m-bx2"><donut-loading-dots /></div>
    <div v-else-if="!tableData.length" class="f-jc m-tx4">
      <div class="f-ac f-v">
        <div class="t">Looks like you haven't redeemed any {{ $i18n.t('shoutouts.reward', { count: 2 }) }} yet!</div>
        <div class="t m-t">
          <span>Head to the </span>
          <a href="/rewards" class="link ul">{{ $i18n.t('shoutouts.rewards_store') }}</a>
          <span> to redeem your hard-earned {{ pointsNoun }}.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, inject } from 'vue';
  import { useStore } from 'vuex';
  import Network from 'lib/api/network';
  import useInfiniteScroll from 'composables/infinite-scroll';

  const { state, dispatch } = useStore();
  const $i18n = inject('$i18n');
  const rewardNoun = $i18n.t('shoutouts.reward', { count: 1 });
  const pointsNoun = computed(() => state.pointsConfig.config.points_name_plural);

  // Data Fetching
  const list = ref([]);
  const nextPage = ref(1);
  const isFetching = ref(false);
  const fetchData = () => new Promise((resolve) => {
      isFetching.value = true;
      Network.get(`/rewards/redemptions/list?for_history=true&page=${nextPage.value}`, {
        success: (data) => {
          list.value = [...list.value, ...data.list];
          nextPage.value = data.nextPage;
          resolve(true);
        },
        error: () => { dispatch('setErrorToast'); },
        complete: () => { isFetching.value = false; },
      });
    });
  const shouldFetchAtEndOfScroll = computed(() => nextPage.value && !isFetching.value);
  useInfiniteScroll({ fetchData, shouldFetchAtEndOfScroll });

  // Table Headers/Data
  const tableHeaders = computed(() => {
    const statusTooltip = 'Redeem link: Access your link to redeem a gift card<br>'
      + `Fulfilled: An admin marked your ${rewardNoun} as fulfilled<br>`
      + `Unfulfilled: You redeemed a ${rewardNoun} but it's not marked as fulfilled yet`;
    return [
      { label: 'Date Redeemed', key: 'redeemed_at' },
      { label: rewardNoun, key: 'reward' },
      { label: pointsNoun.value, key: 'points' },
      // eslint-disable-next-line no-restricted-syntax -- statusTooltip is a hard-coded string
      { label: 'Status', key: 'status', icons: [{ name: 'info', tooltip: { content: statusTooltip, html: true, popperClass: 'tooltip-nowrap' } }] },
    ];
  });
  const tableData = computed(() => list.value.map((redemption) => ({
        ...redemption,
        reward: redemption.listing.name,
        points: redemption.listing.points_cost,
      })));
</script>
